import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../styles/HomePage.css";
import MiloLogo from "../assets/MILO_Logo.png";
import HBSLogo from "../assets/hbs-logo.png";
import ILabLogo from "../assets/ilab-logo.png";

console.log("API URL:", import.meta.env.VITE_API_URL);
console.log("Environment:", import.meta.env.VITE_NODE_ENV);

const HomePage = () => {
  const [showScrollIndicator, setShowScrollIndicator] = useState(true);
  const [miloStarted, setMiloStarted] = useState(false);
  const [traditionalStarted, setTraditionalStarted] = useState(false);
  const [scrollLocked, setScrollLocked] = useState(false);
  const [fadeInDemo, setFadeInDemo] = useState(false);
  const [activeTab, setActiveTab] = useState("milo");


	
  return (
    <div className="homepage-container">
      {/* Hero Section */}
      <section className="hero">
		<div className="hero-content">
		  <img src={MiloLogo} alt="MILO Homes Logo" className="milo-logo-home" />
			<h1 className = "hero-title">Find Your Next Apartment in Minutes – Not Weeks</h1>
			<p className = "hero-subtext">MILO is transforming the apartment search in Boston. Create your rental profile, see only the apartments you qualify for, and lease with confidence</p>
			<div className="hero-buttons">
			  {/*<Link to="/Demo" className="cta-button secondary">Try The Demo</Link>*/}
			  <Link to="/waitlist" className="cta-button primary">Join The Waitlist</Link>
			  <Link to="/Contact/Listing" className="cta-button secondary">List a Property</Link>
			</div>
			<div className="created-at-container">
			  <p className="created-at-text">Built in Boston</p>
			  <div className="created-at-logos">
				<img src={HBSLogo} alt="Harvard Business School Logo" className="created-logo" />
				<img src={ILabLogo} alt="Harvard Innovation Lab Logo" className="created-logo" />
			  </div>
			</div>
		</div>
      </section>
    </div>
  );
};

export default HomePage;
